// Unpublished Work © 2022-2024 Deere & Company.

import ValidationMultiSelect from 'Ui/components/common/form/validation-multi-select';
import SortedMultiSelect from 'Ui/components/common/form/sorted-multi-select';
import ValidationDate from 'Ui/components/common/form/validation-date';
import {DatePicker} from '@deere/isg.component-library';
import dayjs from 'dayjs';
import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {useDeepMemo} from 'Utils/react-utils';
import {isNullOrUndefined} from 'Common/utils/validation-utils';
import moment from 'moment';
import {DATE_FORMATS} from 'Utils/time-utils';

function TimeOffInputs(props) {
    const {
        onChange,
        setValid,
        translations,
        values,
        usersRef,
        statusOptionsRef
    } = props;

    const {
        fromDateError,
        toDateError
    } = useDeepMemo(() => {
        const fromDateError = isNullOrUndefined(values.fromDate) ? translations.REQUIRED_FIELD_TEXT : '';

        let toDateError = isNullOrUndefined(values.toDate) ? translations.REQUIRED_FIELD_TEXT : '';

        if (values.toDate?.isBefore(values.fromDate, 'day')) {
            toDateError = translations.ONLINK_DATES_OUT_OF_ORDER;
        }

        return {
            fromDateError,
            toDateError
        };
    }, [values.fromDate, values.toDate]);

    return (
        <>
            <div className='settings-group mobile'>
                <ValidationMultiSelect
                    component={SortedMultiSelect}
                    defaultSelectLabel={translations.ONLINK_SELECT_ASSIGNEE}
                    items={usersRef.current}
                    label={translations.NAME}
                    name='name'
                    onChange={(ids) => {
                        onChange('name', ids[0]);
                    }}
                    required={true}
                    selectedIds={[values.name]}
                    setValid={setValid}
                    translations
                />
                <ValidationMultiSelect
                    component={SortedMultiSelect}
                    defaultSelectLabel={translations.ONLINK_SELECT_LEAVE_TYPE}
                    items={statusOptionsRef.current}
                    label={translations.ONLINK_LEAVE_TYPE}
                    name='leaveType'
                    onChange={(ids) => {
                        onChange('leaveType', ids[0]);
                    }}
                    required={true}
                    selectedIds={[values.leaveType]}
                    setValid={setValid}
                    translations
                />
            </div>
            <div className='settings-group mobile'>
                <ValidationDate
                    component={DatePicker}
                    helperText={fromDateError}
                    label={translations.ONLINK_FROM}
                    name='fromDate'
                    onChange={(date) => {
                        onChange('fromDate', moment(dayjs(date).format(DATE_FORMATS.day)));
                    }}
                    required={true}
                    setValid={setValid}
                    value={values.fromDate?.toDate() || new Date()}
                />
                <ValidationDate
                    component={DatePicker}
                    dateFormat='L'
                    error={toDateError}
                    label={translations.ONLINK_TO}
                    name='toDate'
                    onChange={(date) => {
                        onChange('toDate', moment(dayjs(date).format(DATE_FORMATS.day)));
                    }}
                    required={true}
                    setValid={setValid}
                    value={values.toDate?.toDate() || new Date()}
                />
            </div>
        </>
    );
}

TimeOffInputs.propTypes = {
    onChange: PropTypes.func,
    setValid: PropTypes.func,
    statusOptionsRef: PropTypes.object,
    translations: PropTypes.translations,
    usersRef: PropTypes.object,
    values: PropTypes.object
};

export default TimeOffInputs;
